<template>
  <div class="derivatives-knowledge">
    <bCardHeader :param="param" class="card-header"></bCardHeader>
    <el-row class="m0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="derivatives-knowledge-content card-base">
          <div class="page-title">
            {{ $t("tradeProduct.derivativesKnowledgeTitle") }}
          </div>
          <div class="derivatives-list" v-for="(item, index) in datalist" :key="index">
            <div class="question">{{ `${index + 1}. ${item.question}` }}</div>
            <div class="options">
              <div class="option" :class="{ isSelected: option.isSelected }" v-for="(option, oindex) in item.options"
                :key="oindex" @click="
                  handleSelectOption(
                    index,
                    oindex,
                    option.value,
                    item.questionNumber
                  )
                  ">
                <img class="icon" :src="require(`@/assets/images/${option.isSelected ? 'icon_sel@2x' : 'icon_nor@2x'
                  }.png`)
                  " alt="" srcset="" />
                <span>{{ `${option.value}. ${option.label}` }}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="footer-btn-group">
              <el-button type="default" class="el-button-back" @click="back">
                {{ $t('common.back') }}
              </el-button>
              <el-button type="primary" class="el-button-sub" @click="next">
                {{ $t('common.submit') }}
              </el-button>
            </div>

          </div>

        </div>
      </el-col>
    </el-row>
    <el-dialog :title="$t('tradeProduct.evaluationResults')" :visible.sync="basicDialog" width="30%" class="warn-dialog"
      :show-close="false">
      <div class="dialog-info">{{ $t('tradeProduct.lackofknowledge') }}</div>
      <div class="dialog-footer">
        <el-button @click="onViewResults">{{ $t('tradeProduct.viewResults') }}</el-button>
        <el-button type="primary" @click="onReEvaluate">{{ $t('tradeProduct.btnReEvaluate') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('tradeProduct.evaluationResults')" :visible.sync="basicTwiceDialog" width="30%"
      class="warn-dialog" :show-close="false">
      <div class="dialog-info">{{ $t('tradeProduct.lackofknowledge') }}</div>
      <div class="lackofknowledge-tip">
        {{ $t("tradeProduct.exceededtwicelimitTip") }}
      </div>
      <div class="dialog-footer">
        <el-button @click="onViewResults">{{ $t('tradeProduct.viewResults') }}</el-button>
        <el-button type="primary" @click="basicTwiceDialog = false">{{ $t('common.gotIt') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="basicExceedTwiceDialog" width="30%" class="warn-dialog" :show-close="false">
      <div class="dialog-info">{{ $t('tradeProduct.exceededtwicelimitTip') }}</div>
      <div class="dialog-footer">
        <el-button type="primary" @click="basicExceedTwiceDialog = false">{{ $t('common.gotIt') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tradeApi from '@/api/v2/trade'
export default {
  data() {
    return {
      basicDialog: false,
      basicTwiceDialog: false,
      basicExceedTwiceDialog: false,
      param: {
        title: 'trade_product',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'trade_product'
          }
        ]
      },
      selectedOptions: [],
      selectedAnswers: Array(10).fill(null),
      datalist: []
    }
  },
  async mounted() {
    await this.handeGetQuestionList()
  },
  methods: {
    back() {
      this.$router.back()
    },
    submitFn() { },
    initData() {
      this.datalist = this.datalist.map(item => ({
        ...item,
        options: item.options.map(option => ({
          ...option,
          isSelected: false // 确保每个选项都有isSelected属性
        }))
      }))
    },
    async handeGetQuestionList() {
      tradeApi.getQuestionList().then(res => {
        if (res.code === 200) {
          this.datalist = res?.data || []
          this.initData()
        }
      })
    },
    onViewResults() {
      this.basicDialog = false
      this.basicTwiceDialog = false
      this.$router.replace('/derivatives-knowledge-result')
    },
    onReEvaluate() {
      this.initData()
      this.selectedAnswers = Array(10).fill(null)
      this.basicDialog = false
    },
    onBasicTwiceDialogClose() {
      this.basicTwiceDialog = false
    },
    async next() {
      // 检查是否有未完成的题目
      const hasNull = this.selectedAnswers.includes(null)
      if (hasNull) {
        this.$message.error(this.$t('tradeProduct.unfinishedReminder'))
      }
      const res = await tradeApi.getDerivativeDayCount()
      // 答题次数
      let limit = res?.data || 0
      if (limit >= 2) {
        this.basicExceedTwiceDialog = true
        return
      }
      // 调用接口
      let submitData = await tradeApi.submitQuestionList(this.selectedAnswers)
      let submitDataObj = submitData?.data || {}
      let score = submitDataObj?.correctNum || 0
      limit = submitDataObj?.dayCount
      // 调用接口
      if (limit === 1 && score < 7) {
        this.basicDialog = true
        return
      }
      if (limit >= 2 && score < 7) {
        this.basicTwiceDialog = true
        return
      }
      if (score >= 7) {
        this.$router.push('/customer-confirmation')
      }
    },
    handleSelectOption(index, oindex, value, questionNumber) {
      // 单选模式：重置所有选项，再设置当前选中
      this.datalist[index].options.forEach(option => {
        option.isSelected = false
      })
      this.$set(this.datalist[index].options[oindex], 'isSelected', true)
      this.$set(this.selectedAnswers, index, {
        questionNumber,
        answer: value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.derivatives-knowledge {
  .derivatives-knowledge-content {
    padding: 24px;

    .page-title {
      font-size: 32px;
      color: #1c212a;
      font-weight: 600;
      margin-bottom: 32px;
    }

    .question {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #111111;
      margin-bottom: 16px;
    }

    .options {
      .option {
        cursor: pointer;
        font-size: 14px;
        color: #1c212a;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 12px;

        &.selected {
          color: #4b596b;
        }

        .icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    .footer-btn-group {
      display: flex;
      align-items: center;
      gap: 12px;

      .el-button-back {
        flex: 1;
        max-width: 250px;
      }

      .el-button-sub {
        flex: 1;
        max-width: 250px;
      }
    }
  }
}

.warn-dialog {
  .dialog-info {
    font-size: 14px;
    font-weight: 400;
    color: #000;
    line-height: 21px;
    text-align: center;
    background: #f2f3f5;
    padding: 12px;

    &:first-of-type {
      margin-bottom: 15px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    .el-button {
      width: 100%;
    }
  }
}
</style>
